<template>
  <div>
    <!-- Form with company number input field -->
    <v-form v-model="valid" ref="form">
      <v-text-field
        v-shortkey="['enter']"
        @shortkey.native="nada()"
        outlined
        :label="label"
        v-model="org"
        v-mask="mask"
        :loading="isLoading"
        placeholder="nnnnnn-nnnn"
        :rules="[rules.required, rules.orgnr]"
        required
      ></v-text-field>
    </v-form>
    <p v-if="isLoading"><v-icon class="mr-1">$sl-spinner</v-icon>Laddar företagsinformation…</p>
  </div>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton'
import API from '@/services/api.js'
import {mask} from 'vue-the-mask'
import {RulesMixin} from '@/components/mixins'
// @group People
// Styled MySettings component
export default {
  name: 'MySettings',
  mixins: [RulesMixin],
  components: {
    ActionButton
  },
  directives: {
    mask
  },

  props: {
    label: {
      type: String,
      default: 'Företagets organisationsnummer'
    }
  },
  data: () => ({
    mask: '######-####',
    org: '',
    isLoading: false,
    valid: false
  }),

  watch: {
    /**
     * @vuese
     * Used to watch the company org number and fetch teh company based on org value
     * @arg The argument is an integer value representing company organization number
     */
    org(val) {
      this.getCompany(val)
    }
  },

  methods: {
    /**
     * @vuese
     * Used fetch the company by org number
     * @arg The argument is an integer value representing org number
     */
    getCompany(val) {
      let noDashOrg = val.replace(/-/g, '')
      if (!noDashOrg || noDashOrg.length !== 10 || !this.$refs.form.validate()) {
        this.isLoading = false
        return
      }

      this.isLoading = true

      API.getCompanyOrg(noDashOrg)
        .then(res => {
          if (res && res.data) {
              console.log('1');
            this.$emit('company', res.data)
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    },
    /**
     * @vuese
     * Used to stop the application if any key except Enter is typed
     * @arg is called without argument
     */
    nada() {}
  }
}
</script>

<style>
</style>